import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    overlay: 'fixed inset-0 z-[10000] bg-black/50',
    contentContainer:
      'group/drawer fixed right-0 bottom-0 left-0 z-[10000] flex max-h-[calc(var(--viewport-height)_-_20px)] flex-col outline-none sm:inset-y-0 sm:mt-0 sm:max-h-none',
    content:
      'w-full flex-1 overflow-y-auto bg-white px-4 py-8 sm:w-[640px] sm:px-20 sm:py-15',
    closeButton:
      'text-icon-main absolute top-3 right-3 hidden size-10 p-2 group-data-[state=closed]/drawer:cursor-default sm:top-6 sm:right-6 sm:flex',
    closeIcon: 'size-8',
    divider:
      'bg-icon-secondary-light absolute -top-4 left-1/2 h-1.5 w-13 -translate-x-1/2 rounded-full transition-opacity duration-300 group-data-[state=closed]/drawer:opacity-0 sm:hidden'
  },
  variants: {
    direction: {
      left: {
        contentContainer: 'sm:inset-y-0 sm:right-auto sm:left-0'
      },
      right: {
        contentContainer: 'sm:inset-y-0 sm:right-0 sm:left-auto'
      },
      bottom: {
        contentContainer:
          'sm:inset-x-0 sm:top-auto sm:bottom-0 sm:max-h-[calc(var(--viewport-height)_-_20px)] sm:w-full',
        content: 'sm:w-full sm:px-4 sm:py-8',
        closeButton: 'sm:hidden',
        divider: 'sm:block'
      }
    },
    withoutMobile: {
      true: {
        contentContainer: 'top-0 max-h-none',
        content: 'py-12',
        divider: 'hidden',
        closeButton: 'flex'
      }
    }
  }
});
